import { render, staticRenderFns } from "./FinancesInvoicesCompanyItemsTable.vue?vue&type=template&id=3b594f12&scoped=true"
import script from "./FinancesInvoicesCompanyItemsTable.vue?vue&type=script&lang=js"
export * from "./FinancesInvoicesCompanyItemsTable.vue?vue&type=script&lang=js"
import style0 from "./FinancesInvoicesCompanyItemsTable.vue?vue&type=style&index=0&id=3b594f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b594f12",
  null
  
)

export default component.exports